import React from 'react';
import Section from '../../components/common/Section';
import FeatureShowcase from '../../components/sections/FeatureShowcase';

/**
 * 客户案例展示页面
 * 展示成功客户的案例和故事
 */
const CustomerCasesPage: React.FC = () => {
  // 电商行业案例数据
  const ecommerceCustomers = [
    {
      id: 'ecommerce-1',
      title: '优选电商',
      description: '通过我们的解决方案，优选电商提升了30%的客户留存率，销售额增长50%。',
      imageUrl: '/assets/images/features/meeting-notes.svg'
    },
    {
      id: 'ecommerce-2',
      title: '全球购物',
      description: '全球购物利用我们的客户管理系统，实现了客户服务响应时间减少60%。',
      imageUrl: '/assets/images/features/work.png'
    },
    {
      id: 'ecommerce-3',
      title: '时尚优品',
      description: '时尚优品借助我们的营销工具，会员数量在3个月内增长了200%。',
      imageUrl: '/assets/images/products/dengbaba.png'
    }
  ];

  // 餐饮行业案例数据
  const foodCustomers = [
    {
      id: 'food-1',
      title: '品味餐厅',
      description: '品味餐厅使用我们的配送系统，外卖订单量提升40%，客户满意度提高25%。',
      imageUrl: '/assets/images/features/meeting-notes.svg'
    },
    {
      id: 'food-2',
      title: '快乐咖啡',
      description: '快乐咖啡通过我们的会员积分系统，复购率提升35%，客单价增长20%。',
      imageUrl: '/assets/images/features/work.png'
    },
    {
      id: 'food-3',
      title: '鲜果饮品',
      description: '鲜果饮品利用我们的商品管理功能，运营效率提升50%，库存损耗降低30%。',
      imageUrl: '/assets/images/products/dengbaba.png'
    }
  ];

  // 零售行业案例数据
  const retailCustomers = [
    {
      id: 'retail-1',
      title: '优家生活',
      description: '优家生活借助我们的全渠道解决方案，线上销售额在半年内翻了一番。',
      imageUrl: '/assets/images/features/meeting-notes.svg'
    },
    {
      id: 'retail-2',
      title: '时代百货',
      description: '时代百货通过我们的客户画像分析，精准营销效果提升45%。',
      imageUrl: '/assets/images/features/work.png'
    },
    {
      id: 'retail-3',
      title: '全球优选',
      description: '全球优选使用我们的供应链管理系统，库存周转率提高40%。',
      imageUrl: '/assets/images/products/dengbaba.png'
    }
  ];

  return (
    <div className="customer-cases-page">
      {/* 页面标题 */}
      <Section
        id="cases-header"
        spacing="medium"
        background="white"
        className="border-b border-gray-100"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center py-8 md:py-12">
            <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4">
              客户案例
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              看看我们如何帮助客户取得成功
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              这些成功案例展示了我们如何帮助各行业客户解决问题、提升效率、实现业务增长
            </p>
          </div>
        </div>
      </Section>

      {/* 电商行业案例 */}
      <Section
        id="ecommerce-cases"
        spacing="large"
        background="background"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FeatureShowcase
            title="电商行业成功案例"
            subtitle="帮助电商企业提升销售、优化运营、增强客户粘性"
            features={ecommerceCustomers}
            columns={3}
          />
        </div>
      </Section>

      {/* 餐饮行业案例 */}
      <Section
        id="food-cases"
        spacing="large"
        background="white"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FeatureShowcase
            title="餐饮行业成功案例"
            subtitle="助力餐饮企业提升效率、优化配送、增加复购"
            features={foodCustomers}
            columns={3}
          />
        </div>
      </Section>

      {/* 零售行业案例 */}
      <Section
        id="retail-cases"
        spacing="large"
        background="background"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FeatureShowcase
            title="零售行业成功案例"
            subtitle="帮助零售企业实现全渠道销售、精准营销、高效库存管理"
            features={retailCustomers}
            columns={3}
          />
        </div>
      </Section>

      {/* 号召性动作区域 */}
      <Section
        id="cases-cta"
        background="white"
        spacing="large"
        className="border-t border-gray-100"
      >
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4">
            成为下一个成功案例
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">准备好开始您的成功之旅了吗？</h2>
          <p className="text-gray-600 max-w-3xl mx-auto mb-8 text-lg">
            立即联系我们，了解我们如何帮助您的企业提升效率、增加销售、实现业务增长
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button className="px-8 py-4 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-medium text-lg shadow-sm">
              免费咨询
            </button>
            <button className="px-8 py-4 bg-white border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium text-lg">
              预约演示
            </button>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default CustomerCasesPage;